export default "__VITE_PUBLIC_ASSET__c68a975a__"